import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from "@angular/core";
import { IProjectAOI } from "../../../../interfaces/i-project-aoi";
import { CollectionProjectSharedTimelineComponent } from "../timeline/collection-project-shared-timeline.component";
import { FeatureFlagsService } from "../../../../services/internal-services/feature-flags.service";
import { MapService } from "../../../../services/internal-services/map.service";
import { GoogleAnalyticsService } from "../../../../../shared/services/google-analytics.service";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-sbs-projects-timeline",
  templateUrl: "../../projects/projects-timeline.component.html",
  styleUrls: ["../../base/timeline/base-timeline.component.scss"],
  standalone: false,
})
export class SbsTimelineComponent extends CollectionProjectSharedTimelineComponent {
  constructor(
    public googleAnalyticsService: GoogleAnalyticsService,
    public cdr: ChangeDetectorRef,
    public flagService: FeatureFlagsService,
    public mapService: MapService,
  ) {
    super(googleAnalyticsService, cdr, flagService, mapService);
  }

  @Output() layerChange = new EventEmitter<IProjectAOI>();

  private visibleAOI: IProjectAOI;

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.centerAOI = this.visibleAOI;
  }

  onChangeProject(value: number): void {
    const aoi = this._aois[value];
    this.layerChange.emit(aoi);

    this.updateFiltersByAOI(aoi);

    this.sendAnalyticsEvent(aoi);
  }

  @Input()
  set aoi(aoi: IProjectAOI) {
    if (aoi) {
      const visible = this.checkVisibleAOI(aoi);
      this.visibleAOI = visible;
      this.centerAOI = visible;
      if (aoi?.getLayerId() !== visible?.getLayerId()) {
        this.layerChange.emit(visible);
      }
    }
  }

  @Input()
  override set aois(aois: IProjectAOI[]) {
    super.aois = aois;
    this.updateAois(aois);
    this.aoi = this.visibleAOI; // check  if the selected aoi is visible, if not we change for other aoi
  }

  checkVisibleAOI(aoi: IProjectAOI) {
    if (!aoi) {
      return null;
    }
    const visibleAOIs = this._aois.filter((l) => l.isVisible());
    const exists = visibleAOIs.find((l) => l.getLayerId() === aoi.getLayerId());
    if (exists) {
      return aoi;
    }
    // if layer is not in the visible aois we get the next or if not exists the first fo the array
    const newAOI = visibleAOIs.find((l) => l.maxDate > aoi.maxDate);
    return newAOI || this._aois[0];
  }
}
